import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '6px',
		mb: 1,
	},
	button: {
		minWidth: 0,
		padding: '2px 9px',
		fontSize: '12px',
		textTransform: 'none',
		borderRadius: '8px',
	},
	range: {
		ml: 'auto',
		fontSize: '12px',
		color: 'text.secondary',
	},
	note: {
		fontSize: '12px',
		color: 'text.secondary',
		mb: 0.5,
	},
	stage: {
		position: 'relative',
		touchAction: 'pan-y',
		userSelect: 'none',
	},
	tip: {
		position: 'absolute',
		pointerEvents: 'none',
		zIndex: 10,
		backgroundColor: 'rgba(31, 41, 55, 0.95)',
		color: '#fff',
		fontSize: '12px',
		lineHeight: 1.45,
		padding: '6px 9px',
		borderRadius: '6px',
		whiteSpace: 'nowrap',
	},
} as const satisfies SxType
